const Error = () => <>oops</>;

export default Error;
